// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "dist/" + "main" + "." + "639a8fcd22f4f3e704a2" + ".css";
};